import {ADMIN_ROUTE_CONSTANTS} from '@shared/constants/routes';
import {MenuItem} from 'primeng/api';

const adminBase = `/${ADMIN_ROUTE_CONSTANTS.path}`;

export const FINANCE: MenuItem = {
  id: 'tour-menu-finance',
  label: ADMIN_ROUTE_CONSTANTS.finance.data.breadcrumb,
  icon: ADMIN_ROUTE_CONSTANTS.finance.data.icon,
  hasSubmenu: true,
  expanded: false,
  items: [
    {
      label: ADMIN_ROUTE_CONSTANTS.finance.dashboard.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.finance.dashboard.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.finance.path}/${ADMIN_ROUTE_CONSTANTS.finance.dashboard.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.finance.invoices.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.finance.invoices.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.finance.path}/${ADMIN_ROUTE_CONSTANTS.finance.invoices.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.finance.payments.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.finance.payments.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.finance.path}/${ADMIN_ROUTE_CONSTANTS.finance.payments.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.finance.collections.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.finance.collections.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.finance.path}/${ADMIN_ROUTE_CONSTANTS.finance.collections.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.finance.unitStatements.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.finance.unitStatements.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.finance.path}/${ADMIN_ROUTE_CONSTANTS.finance.unitStatements.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.finance.expenses.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.finance.expenses.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.finance.path}/${ADMIN_ROUTE_CONSTANTS.finance.expenses.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.finance.transactions.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.finance.transactions.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.finance.path}/${ADMIN_ROUTE_CONSTANTS.finance.transactions.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.finance.accounts.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.finance.accounts.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.finance.path}/${ADMIN_ROUTE_CONSTANTS.finance.accounts.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.finance.banks.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.finance.banks.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.finance.path}/${ADMIN_ROUTE_CONSTANTS.finance.banks.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.finance.budgets.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.finance.budgets.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.finance.path}/${ADMIN_ROUTE_CONSTANTS.finance.budgets.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.finance.bankReconciliation.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.finance.bankReconciliation.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.finance.path}/${ADMIN_ROUTE_CONSTANTS.finance.bankReconciliation.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.finance.dgii.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.finance.dgii.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.finance.path}/${ADMIN_ROUTE_CONSTANTS.finance.dgii.path}`
    }
  ]
};
